<template>
  <BreadCrumb :items="breadcrumbItems" />
  <main id="main">
    <SponsorDtlForm :sponsorSeq = sponsorSeq />
  </main>
</template>
<script>
import SponsorDtlForm from '@/components/sponsor/SponsorDtlForm.vue';
import BreadCrumb from "../layout/navigation/BreadCrumb.vue";

export default {
  data() {
    return {
      breadcrumbItems: [
        { href: "/", text: "홈", isHome: true },
        { href: "/sponsor", text: "후원활동" },
        { href: "#", text: "후원활동 상세" },
      ],
    };
  },
  props: {
    sponsorSeq: {
      type: String,
      required: true
    },
  },
  components: {
    BreadCrumb,
    SponsorDtlForm
  }
}
</script>
<style>
    
</style>